import { Button } from "@xola/ui-kit";
import React from "react";
import { AppStatus } from "./useEmbeddedAppSession";

const STATUS_LABEL: Record<AppStatus, string> = {
    loading: "Loading...",
    waking: "Waking app...",
    ready: "",
    broken: "Failed to load",
};

interface EmbeddedAppChromeProps {
    appName: string;
    status: AppStatus;
    isLongWaking: boolean;
    onReload: () => void;
}

export const EmbeddedAppChrome = ({ appName, status, isLongWaking, onReload }: EmbeddedAppChromeProps) => {
    const label = status === "waking" && isLongWaking ? "Still waking, taking longer than usual" : STATUS_LABEL[status];

    return (
        <div className="flex h-10 flex-shrink-0 items-center justify-between border-b border-gray-light bg-white px-3">
            <span className="truncate text-sm font-semibold">{appName}</span>
            <div className="flex items-center gap-2">
                {label ? <span className="text-xs text-gray-dark">{label}</span> : null}
                <Button size="small" variant="link" aria-label="Reload app" onClick={onReload}>
                    Reload
                </Button>
            </div>
        </div>
    );
};
